module.exports = __webpack_public_path__ + "static/media/cases_3d_03a.c5cdd009.jpg";